import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, QrCodeIcon, ReceiptIcon, ArrowRightLeftIcon, CheckCircle2 } from 'lucide-react';
const steps = [{
  icon: <UsersIcon className="w-6 h-6 text-kitty-dark" data-id="element-153" data-mp="7qipvm3tws95" />,
  title: 'Create a kitty',
  description: 'Start a shared kitty for a trip, night out, house share or event, and name it whatever your group calls it.'
}, {
  icon: <QrCodeIcon className="w-6 h-6 text-kitty-dark" data-id="element-154" data-mp="lka3b5kokwa5" />,
  title: 'Invite the group',
  description: 'Share a link, code or QR, pick people from your contacts, or add someone by name for them to claim later.'
}, {
  icon: <ReceiptIcon className="w-6 h-6 text-kitty-dark" data-id="element-155" data-mp="cshuezbb1v7o" />,
  title: 'Add the spends',
  description: 'Enter what was spent, set who paid, and choose exactly who the spend is shared with. Attach a receipt if you want a record.'
}, {
  icon: <ArrowRightLeftIcon className="w-6 h-6 text-kitty-dark" data-id="element-156" data-mp="14hkyadza53js" />,
  title: 'See who owes who',
  description: 'KittyPot works out a simple way for everyone to settle up, with a breakdown behind every amount.'
}, {
  icon: <CheckCircle2 className="w-6 h-6 text-kitty-dark" data-id="element-157" data-mp="2rlxon2p7ky4m" />,
  title: 'Settle up your way',
  description: 'Pay by bank transfer or cash, mark it as paid, and the person receiving it confirms when it lands.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-28 lg:py-36 bg-white" data-id="element-158" data-mp="2wk8zngr8peof">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159" data-mp="2wixvhftvu4ws">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-160" data-mp="3aaui54cs7mls">
          <div className="inline-flex bg-kitty-yellow-100 text-kitty-yellow-800 rounded-full px-3 py-1 text-xs font-semibold mb-4" data-id="element-161" data-mp="36b3mam8eegae">
            How it works
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-162" data-mp="3k7z7te5u607c">
            Group money made simple.
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto mb-3" data-id="element-163" data-mp="1pxdhfd9gfnzp">
            Create a shared kitty, track what everyone spends, and settle up
            together when the trip is done.
          </p>
          <p className="text-sm font-semibold text-kitty-dark/50 mb-5" data-id="element-164" data-mp="3l0iga4pwnipo">
            Clear costs. Fair splits. Simple settlement.
          </p>
        </div>

        <div className="relative" data-id="element-165" data-mp="3u05ao6k7vo98">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0 border-t-2 border-dashed border-kitty-yellow-200 -z-10" data-id="element-166" data-mp="3u29l77cmflih" />

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-4" data-id="element-167" data-mp="7tqioo2rh54b">
            {steps.map((step, index) => <motion.div key={step.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-168" data-mp="cr06jzai58q1" data-mpi={index}>
                <div className="w-24 h-24 rounded-3xl bg-kitty-yellow-50 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow-100 transition-colors relative shadow-sm border border-kitty-yellow-100" data-id="element-169" data-mp="vjb3lcih6cg8">
                  {/* Number badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-170" data-mp="voah9yfwvxst">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-lg font-bold text-kitty-dark mb-2" data-id="element-171" data-mp="1jduyocwf2mzz">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-172" data-mp="1emmsdpqdvhr1">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}